// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zFa6pU93xUUVliMN{display:flex;justify-content:flex-start;align-items:center;height:100%;width:100%;margin-top:24px;flex-direction:column}.Kp_3dnS80VKtF2oE{width:880px}.Kp_3dnS80VKtF2oE.zhGrBabqNdA4vldH{width:654px;max-width:100%}.Kp_3dnS80VKtF2oE .cBbja1JoEZU_fXuB{display:flex;flex-direction:column;row-gap:8px}.Kp_3dnS80VKtF2oE .Ukr1YZr651497bmH{display:flex;flex-direction:column;row-gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `zFa6pU93xUUVliMN`,
	"columnsContainer": `Kp_3dnS80VKtF2oE`,
	"stackedView": `zhGrBabqNdA4vldH`,
	"mainColumnContainer": `cBbja1JoEZU_fXuB`,
	"secondaryColumnContainer": `Ukr1YZr651497bmH`
};
export default ___CSS_LOADER_EXPORT___;
